import { render, staticRenderFns } from "./mailForm.vue?vue&type=template&id=5abb6354&scoped=true"
import script from "./mailForm.vue?vue&type=script&lang=js"
export * from "./mailForm.vue?vue&type=script&lang=js"
import style0 from "./mailForm.vue?vue&type=style&index=0&id=5abb6354&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb6354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abb6354')) {
      api.createRecord('5abb6354', component.options)
    } else {
      api.reload('5abb6354', component.options)
    }
    module.hot.accept("./mailForm.vue?vue&type=template&id=5abb6354&scoped=true", function () {
      api.rerender('5abb6354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/mailForm.vue"
export default component.exports